<template>

    <m-edit1/>

    <m-factor-8 v-bind='{...{"redirectPage":"https:\/\/kiosk.arair.ir\/"},...{}}' :style='""' class="" ></m-factor-8>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor8 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor8';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor8 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
